// PersonModal.jsx – FINAL with FULL DEBUG (Same as Sidebar)

import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { InsertToServer } from "../api/ServerApi";

const ENABLE_DEBUG = false; // 🔥 set true to see the raw API payload/response


function PersonModal({ person, corporationId, onClose }) {
  const [saving, setSaving] = useState(false);

  /* ================= DEBUG ================= */
  const [showDebugToast, setShowDebugToast] = useState(false);
  const [debugInfo, setDebugInfo] = useState({
    api: "",
    payload: null,
    response: null,
    error: null,
  });

  const [form, setForm] = useState({
    VoterFullName: "",
    Address: "",
    CardNo: "",
    MobileNumber: "",
    EmailId: "",
    Caste: "",
    Category: "General",
    Shifted: "No",
    LastTimeCastedVote: "Yes",
    Reason: "",
    FavourModiji: 5,
    Influencer: 5,
    Qualification: "",
    Occupation: "",
  });

  /* ================= LOAD PERSON ================= */
  useEffect(() => {
    if (!person) return;

    setForm({
      VoterFullName:
        `${person.esurname || ""} ${person.name_english || ""} ${person.relative_english || ""}`
          .replace(/\s+/g, " ")
          .trim(),
      Address: person.address || "",
      CardNo: person.CardNo || "",
      MobileNumber: person.MobileNumber || "",
      EmailId: person.EmailId || "",
      Caste: person.Caste || "",
      Category: person.Category || "General",
      Shifted: person.Shifted || "No",
      LastTimeCastedVote: person.LastTimeCastedVote || "Yes",
      Reason: person.Reason || "",
      FavourModiji: person.FavourModiji || 5,
      Influencer: person.Influencer || 5,
      Qualification: person.Qualification || "",
      Occupation: person.Occupation || "",
    });
  }, [person]);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!person) return;

    const payload = {
      CorporationId: Number(corporationId),
      PanelNumber: Number(person.PanelNumber),
      VoterNumber: Number(person.VoterNumber),

      CardNo: form.CardNo,
      MobileNumber: form.MobileNumber,
      Address: form.Address,
      EmailId: form.EmailId,
      Caste: form.Caste,
      Category: form.Category,
      Shifted: form.Shifted,
      LastTimeCastedVote: form.LastTimeCastedVote,
      Reason: form.Reason,
      FavourModiji: Number(form.FavourModiji),
      Influencer: Number(form.Influencer),
      Qualification: form.Qualification,
      Occupation: form.Occupation,
    };

    const apiName = "AddPanelVoterDetails";

    setSaving(true);
    try {
      const response = await InsertToServer(
        apiName,
        payload,
        { plain: true }
      );

      // ✅ DEBUG SUCCESS
      setDebugInfo({
        api: apiName,
        payload,
        response,
        error: null,
      });
      setShowDebugToast(true);

      if (!ENABLE_DEBUG) {
        alert("Voter details saved successfully");
        onClose();
      }

    } catch (err) {
      // ✅ DEBUG ERROR
      setDebugInfo({
        api: apiName,
        payload,
        response: null,
        error: err?.message || err,
      });
      setShowDebugToast(true);

      if (!ENABLE_DEBUG) {
        alert("Failed to save voter details");
      }

    } finally {
      setSaving(false);
    }
  };

  if (!person) return null;

  return (
    <>
      {/* ================= MODAL ================= */}
      <div style={overlay}>
        <div style={modal}>
          <div style={header}>
            <b>Voter Details</b>
            <button onClick={onClose} style={closeBtn}>✕</button>
          </div>

          <div style={body}>
            <div style={grid}>
              <Field label="Full Name" value={form.VoterFullName} disabled />
              <Field
                label="Mobile"
                value={form.MobileNumber}
                onChange={(v) => update("MobileNumber", v.replace(/\D/g, ""))}
              />
              <Field label="Card No" value={form.CardNo} disabled />
              <Field label="Email" value={form.EmailId}
                onChange={(v) => update("EmailId", v)} />

              <FullField label="Address" value={form.Address}
                onChange={(v) => update("Address", v)} />

              <Field label="Caste" value={form.Caste}
                onChange={(v) => update("Caste", v)} />

              <Select label="Category" value={form.Category}
                options={["General", "SC", "ST", "OBC", "EWS"]}
                onChange={(v) => update("Category", v)} />

              <Select label="Shifted" value={form.Shifted}
                options={["No", "Yes"]}
                onChange={(v) => update("Shifted", v)} />

              <Select label="Last Voted" value={form.LastTimeCastedVote}
                options={["Yes", "No"]}
                onChange={(v) => update("LastTimeCastedVote", v)} />

              <Field label="Favour Modiji" type="number"
                value={form.FavourModiji}
                onChange={(v) => update("FavourModiji", v)} />

              <Field label="Influencer" type="number"
                value={form.Influencer}
                onChange={(v) => update("Influencer", v)} />

              <Field label="Qualification"
                value={form.Qualification}
                onChange={(v) => update("Qualification", v)} />

              <Field label="Occupation"
                value={form.Occupation}
                onChange={(v) => update("Occupation", v)} />

              <FullField label="Reason" value={form.Reason}
                onChange={(v) => update("Reason", v)} />
            </div>
          </div>

          <div style={footer}>
            <button onClick={onClose}>Cancel</button>
            <button onClick={handleSave} disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>

      {/* ================= DEBUG TOAST (SAME AS SIDEBAR) ================= */}
      <Modal
        show={showDebugToast}
        onHide={() => setShowDebugToast(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>API Debug Info</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ fontSize: 13 }}>
          <b>API:</b>
          <pre>{debugInfo.api}</pre>

          <b>Payload:</b>
          <pre>{JSON.stringify(debugInfo.payload, null, 2)}</pre>

          <b>Response:</b>
          <pre style={{ maxHeight: 200, overflow: "auto" }}>
            {JSON.stringify(debugInfo.response, null, 2)}
          </pre>

          {debugInfo.error && (
            <>
              <b style={{ color: "red" }}>Error:</b>
              <pre>{String(debugInfo.error)}</pre>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDebugToast(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

/* ---------- SMALL COMPONENTS ---------- */

const Field = ({ label, value, onChange, disabled, type = "text" }) => (
  <div style={field}>
    <label>{label}</label>
    <input
      type={type}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.value)}
    />
  </div>
);

const FullField = (props) => (
  <div style={{ gridColumn: "1 / -1" }}>
    <Field {...props} />
  </div>
);

const Select = ({ label, value, options, onChange }) => (
  <div style={field}>
    <label>{label}</label>
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((o) => (
        <option key={o}>{o}</option>
      ))}
    </select>
  </div>
);

/* ---------- STYLES ---------- */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modal = {
  width: "820px",
  background: "#fff",
  borderRadius: 8,
  display: "flex",
  flexDirection: "column",
};

const header = {
  padding: "6px 10px",
  borderBottom: "1px solid #ddd",
  display: "flex",
  justifyContent: "space-between",
};

const body = { padding: 8 };

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 6,
};

const field = {
  display: "flex",
  flexDirection: "column",
  fontSize: 11,
};

const footer = {
  padding: 8,
  borderTop: "1px solid #ddd",
  display: "flex",
  justifyContent: "flex-end",
  gap: 8,
};

const closeBtn = {
  background: "#333",
  color: "#fff",
  border: "none",
  padding: "2px 8px",
  cursor: "pointer",
};

export default PersonModal;
